import { type ShortUrlResponse } from '@air/api/types';

/**
 * In create mode the link doesn't exist yet, so we synthesize a `shortIdInfo` shape from local draft
 * state. PasscodeProtectionRow / ExpirationDateRow only read `passcode`, `expirationDate`, and `id`
 * from this object. The `id: ''` MUST be preserved — those rows skip their own analytics when the id
 * is empty (create has no link to attribute the change to yet).
 */
export function buildDraftShortIdInfo(
  passcode: string | null,
  disabled: boolean,
  expirationDate: string | null,
  permissions: ShortUrlResponse['permissions'],
  presentationSettings: ShortUrlResponse['presentationSettings'],
): ShortUrlResponse {
  return {
    id: '',
    passcode,
    disabled,
    requireAccount: false,
    expirationDate,
    createdBy: '',
    createdAt: '',
    boardContext: '',
    permissions,
    presentationSettings,
  };
}
